import { useEffect, useState } from 'react';
import useContactInfo from './widget/hooks/useContactInfo';
import { ContactComponent } from './ContactComponent';
import { ContactInfo } from '../models/ContactInfo';
import { ContactLoadingSkeleton } from './loadingSkeleton/ContactLoadingSkeleton';
import { ContactWidgetState } from '../models/ContactWidgetState';

interface ContactWidgetWebshopProps {
  data: string;
}

export const ContactWidgetWebshop = ({ data }: ContactWidgetWebshopProps) => {
  if (!data || data === '{}') return <></>;

  const contactData = JSON.parse(data) as ContactWidgetState;

  const { contactInfo, loading } = useContactInfo();

  const [widgetState, setWidgetState] = useState<ContactWidgetState>({
    widgetTitle: {
      hu: { title: '' },
    },
    backgroundColor: '#ffffff',
    iconColor: '#000000',
    textColor: '#000000',
  });
  const updateWidgetStateFromContactInfo = (contactInfo: ContactInfo) => {
    setWidgetState((prevState) => ({
      ...prevState,
      socialMedia: [
        { icon: 'facebook', link: contactInfo.facebookLink || '' },
        { icon: 'instagram', link: contactInfo.instagramLink || '' },
        { icon: 'tripadvisor', link: contactInfo.tripAdvisorLink || '' },
        { icon: 'youtube', link: contactInfo.youtubeLink || '' },
      ].filter((socialMedia) => socialMedia.link),
    }));
  };

  // Usage in useEffect or wherever you receive the contactInfo
  useEffect(() => {
    if (contactInfo) {
      updateWidgetStateFromContactInfo(contactInfo);
    }
  }, [contactInfo]);
  if (loading) return <ContactLoadingSkeleton />;
  return (
    <ContactComponent
      address={contactInfo?.address}
      city={contactInfo?.city}
      zipCode={contactInfo?.zipCode}
      title={contactInfo?.title}
      email={contactInfo?.email}
      phone={contactInfo?.phone}
      iconColor={contactData.iconColor}
      textColor={contactData.textColor}
      backgroundColor={contactData.backgroundColor}
      socialMedia={widgetState.socialMedia}
      lat={contactInfo?.lat}
      lng={contactInfo?.lng}
      widgetTitle={contactData.widgetTitle}
    />
  );
};
